const Templates = ({ imgName, id, showPopUp }) => {
    return (
        <>
            <div className="col-lg-4 col-md-6 col-sm-12  temp-blk">
                <div className="temp-list">
                    <img src={imgName} alt="Entab" className="img-fluid"
                    loading="lazy"
                    decoding="async"
                   
                    
                    />
                    <div className="button-overlay">
                        <button onClick={() => showPopUp(id)} id={id}>View Template</button>
                    </div>
                </div>
                <hr />
            </div>

        </>
    )
}
export default Templates